export default function Avatar({ name, size = 34, bg = '#1C2E3C', color = '#fff' }) {
  const initials = name.split(' ').map(w => w[0]).join('');
  return (
    <div
      className="rounded-full flex items-center justify-center font-semibold shrink-0"
      style={{ width: size, height: size, background: bg, color, fontSize: size * 0.35 }}
    >
      {initials}
    </div>
  );
}
